module.exports = __webpack_public_path__ + "img/11.8145d003.jpg";